// extracted by mini-css-extract-plugin
export default {"menu_title":"menu_dropdown_menu_title__Ypfkn","dropdown_menu":"menu_dropdown_dropdown_menu__1fWPn","menu_item":"menu_dropdown_menu_item__tOT5V"};